import { GridTemplateValue } from '@billy/design-system'
import mean from 'lodash/mean'

import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

type InvoiceLineColumnWidths = {
  [key in InvoiceLineColumn]: GridTemplateValue
}

export const INVOICE_LINE_COLUMNS_WIDTHS: Partial<InvoiceLineColumnWidths> = {
  description: 8,
  discount: 8,
  productType: '74px',
  date: 5,
  quantity: 4,
  unit: 4,
  unitPrice: 5,
  vatPct: 4,
  netTotal: 5,
  total: 5,
}

export const AVERAGE_COLUMN_WIDTH = Math.round(mean(Object.values(INVOICE_LINE_COLUMNS_WIDTHS)))
